<template>
  <section class="c-section section">
    <span
      class="section__bg"
      v-if="data.video === undefined"
      :style="{
        backgroundImage: `url(${data.img.src})`,
      }"
    />
    <div class="section__bg-cont">
      <video
        class="section__bg"
        v-if="data.video !== undefined"
        :poster="data.img.src"
        ref="video"
        playsinline
        autoplay
        muted
        loop
      >
        <source :src="data.video.src" type="video/mp4">
      </video>
    </div>
    <slot></slot>
  </section>
</template>

<script>
import { TweenMax, Power4 } from 'gsap/TweenMax';

export default {
  name: 'AppSection',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    if (this.video !== undefined) {
      TweenMax.set(this.$refs.video, { autoAlpha: 0, scale: 1.2 });
      this.handleVideoPlay = () => this.videoPlay();
      this.$refs.video.addEventListener('canplay', this.handleVideoPlay);
    }
  },
  methods: {
    videoPlay() {
      TweenMax.to(this.$refs.video, 1, { autoAlpha: 1, scale: 1, ease: Power4.easeOut });
    },
  },
  beforeDestroy() {
    if (this.video !== undefined) this.$refs.video.removeEventListener('canplay', this.handleVideoPlay);
  },
};
</script>

<style lang="scss" scoped>
.section {
  position: relative;
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  padding: 0 20px;
  box-sizing: border-box;

  @include mq(ipadL) {
    padding: 0 80px;
  }

  display: flex;
  overflow: hidden;

  span.section__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;

    z-index: -1;
  }

  .section__bg-cont {
    position: absolute;
    top: 50%;
    left: 50%;
    width: auto;

    z-index: -1;

    transform: translateX(-50%) translateY(-50%);
  }

  video {
    position: relative;

    @media (min-aspect-ratio: 16/9) {
      width: 100vw;
      height: auto;
    }

    @media (max-aspect-ratio: 16/9) {
      width: auto;
      height: 100vh;
    }
  }
}
</style>
